define('view/people/contact.detail.page.view',['require','exports','module','uikit/uikit','blockit','./contact.detail.view','./people.left.nav','fukit/fukit','backbone.radio'],function(require, exports, module) {
  //prettier-ignore
  var UIKit             = require('uikit/uikit'),
      BlocKit           = require('blockit'),
      ContactDetailView = require('./contact.detail.view'),
      PeopleLeftNav     = require('./people.left.nav'),
      ROLES             = require('fukit/fukit').Roles,
      Radio             = require('backbone.radio');

  //behaviors
  // var AuthorizationBehavior                 = require('behavior/authorization.behavior');
  //
  // var ANY_PERSON_PROFILE_ROLE = [ROLES.PERSON_PROFILE_CREATE, ROLES.PERSON_PROFILE_READ, ROLES.PERSON_PROFILE_UPDATE, ROLES.PERSON_PROFILE_DELETE];
  // var ANY_INTERNAL_AFFILIATION_ROLE = [ROLES.PERSON_INTERNAL_AFFILIATION_CREATE, ROLES.PERSON_INTERNAL_AFFILIATION_READ, ROLES.PERSON_INTERNAL_AFFILIATION_UPDATE, ROLES.PERSON_INTERNAL_AFFILIATION_DELETE];

  var ContactDetailPage = BlocKit.ResolveOptionsView.extend({
    resolveOptions: {
      root: {
        type: BlocKit.TwoColumnLeftRailLayoutView,

        pageHeader: {
          headerText: 'My Profile',
          breadcrumbs: [
            {
              text: 'My Profile',
            },
            {
              text: '',
              route: 'profile:detail',
              behaviors: {
                updateCrumbWithPersonNameBehavior: {
                  behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                  optionValues: {
                    text: {
                      model: '@resources.person',
                      formatter: function(model) {
                        var userPrincipalModel = Radio.request(
                          'AppKit.resourceService',
                          'resource',
                          'userPrincipalModel'
                        );
                        var displayName = 'Current User';
                        var fullName = userPrincipalModel.get('fullName');
                        var username = userPrincipalModel.get('username');

                        displayName = model.get('fullName');
                        if (displayName.trim().length === 0) {
                          if (fullName && fullName.trim().length > 0) {
                            displayName = fullName;
                          } else if (username && username.length > 0) {
                            displayName = username;
                          }
                        }

                        return displayName;
                      },
                    },
                  },
                },
              },
            },
            {
              text: 'Contact Info',
            },
          ],
        },
        contentColumn: {
          components: [
            {
              type: ContactDetailView,
              country: '@resources.country',
              subdivision: '@resources.subdivision',
              model: '@resources.contact',
              // behaviors: {
              //   AuthorizationBehavior: {
              //     visibleOnlyWhen: [
              //       {
              //         filter: function() {
              //           return true
              //         },
              //         message: 'You do not have permission to view this page.',
              //         roles: [ANY_INTERNAL_AFFILIATION_ROLE, ANY_PERSON_PROFILE_ROLE]
              //       }
              //     ],
              //     behaviorClass: AuthorizationBehavior
              //   }
              // }
            },
          ],
        },
        railColumn: {
          components: [
            {
              type: PeopleLeftNav,
            },
          ],
        },
      },
    },
  });

  module.exports = ContactDetailPage;
});

